module.exports = function(PluginManager) {
  PluginManager.registerDependency('sources/device', require('./sources/device'));
  PluginManager.registerVisitorProfileProvider(require('./providers/device'));
  PluginManager.registerAudienceMatcher('device', require('./matchers/device'));
};
